import type { Control } from "react-hook-form";
import {
	ClientPortfolioDomainEnum,
	ClientPortfolioToolTypeEnum,
} from "web_myplann/Infrastructure/Api/Api";
import {
	Resources,
	useResource,
} from "web_myplann/Infrastructure/Translations/Resources";
import type {
	BankProductEditFormInput,
	BankProductEditFormOutput,
} from "web_myplann/Portfolio/Forms/BankProductForm/bankProductFormSchema";
import { InvestmentAdditionalFields } from "web_myplann/Portfolio/Forms/InvestmentForm/InvestmentAdditionalFields";
import { InvestmentBasicFields } from "web_myplann/Portfolio/Forms/InvestmentForm/InvestmentBasicFields";
import { InvestmentToolsSection } from "web_myplann/Portfolio/Forms/InvestmentForm/InvestmentToolsSection";

type BankProductEditFormFieldsProps = {
	control: Control<
		BankProductEditFormInput,
		unknown,
		BankProductEditFormOutput
	>;
	disableKeyFields?: boolean;
};

export const BankProductEditFormFields = ({
	control,
	disableKeyFields,
}: BankProductEditFormFieldsProps) => {
	const { t } = useResource();

	return (
		<>
			<InvestmentBasicFields
				control={control}
				disableKeyFields={disableKeyFields}
				domain={ClientPortfolioDomainEnum.BankingProducts}
				namePlaceholder={t(
					Resources.Portfolio.AddBankProduct.Placeholders.name,
				)}
			/>
			<InvestmentToolsSection
				control={control}
				defaultToolType={ClientPortfolioToolTypeEnum.BankProduct}
			/>
			<InvestmentAdditionalFields
				control={control}
				disableKeyFields={disableKeyFields}
				signedAtLabel={t(Resources.Portfolio.AddBankProduct.Fields.signedAt)}
			/>
		</>
	);
};
